module.exports = __webpack_public_path__ + "img/backyard-pond.4b6a6798.webp";